<template>

  <v-app>
    
    <!-- menu superior -->
    <v-app-bar class="" app color="white" v-resize="onResize" extension-height="320" flat
    height="90">
      <!-- logo -->
      <div class="d-flex align-center mx-5 ">
        <router-link to="/">
          <v-img

            alt="deLuna"
            class="shrink mr-2"
            contain
            
            src="@/assets/central.png"
            transition="scale-transition"
          />
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <!-- boton de menu (modo estrecho) -->
      <v-btn class="hidden-md-and-up" outlined text @click="menu = !menu">
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <!-- botones (modo ancho) -->
      <span class="hidden-sm-and-down">
        <div > 
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mx-1" text color="grey" v-on="on">
            {{ $t("ciudad") }}
            </v-btn>
          </template>

          <v-card class="mx-auto" max-width="300">
            <v-list >
              <v-list-item-group>
                <v-list-item v-for="(accion, indice) in accionesCiudad" :key="indice" @click="zonaEmisiones(accion.clave)">
                  <v-list-item-content>
                    <v-list-item-title v-text="$t(accion.titulo)"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu> -->
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mx-1" text color="grey" v-on="on">
            {{ $t("accionesReserva") }}
            </v-btn>
          </template>

          <v-card class="mx-auto" max-width="200">
            <v-list >
              <v-list-item-group>
                <v-list-item v-for="(accion, indice) in acciones" :key="indice" @click="elegirAccionConReserva(accion.clave)">
                  <v-list-item-content>
                    <v-list-item-title v-text="$t(accion.titulo)"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu>
        <v-btn  to="/comofunciona" class="mx-1" color="grey" text>{{ $t("menuFuncionamiento") }}</v-btn>

        <v-btn   @click="entrarPagina('nuestrosparkings')"  class="mx-1" color="grey" text>{{ $t("menuNuestrosParkings") }}</v-btn>

        <v-btn  @click="entrarPagina('faq')"  class="mx-1" color="grey" text>{{ $t("menuFaq") }}</v-btn>
      </div>
      </span>
    
     <span class="hidden-sm-and-down">

        <!-- selector de idioma -->
        <SelectorIdioma  v-model="idioma" @seleccion="cambiarIdioma" />
     </span>

      <!-- opciones de menu desplegable (modo estrecho) -->
      <template v-if="menu" v-slot:extension>
        <v-container style="height: 275px">
          <v-row justify="center" class="pb-2">
            <!-- <v-btn @click="reservarEstancia()" class="mx-auto white--text" color="#f08823" button>{{ $t("menuReservar") }}</v-btn> -->
          </v-row>
          <v-row justify="center" class="pb-2">
            <v-btn to="/comofunciona" class="mx-1" color="grey" text>{{ $t("menuFuncionamiento") }}</v-btn>
          </v-row>

          <v-row justify="center" class="pb-2">
            <v-btn @click="entrarPagina('nuestrosparkings')" class="mx-1" color="grey" text>{{ $t("menuNuestrosParkings") }}</v-btn>
<!--            <v-btn to="/contacto" class="mx-1" color="grey" text>{{ $t("menuContacto") }}</v-btn> -->
          </v-row>

          <v-row justify="center" class="pb-2">
          </v-row>
          <v-row justify="center" class="pb-2">
<!--            <BuscarReserva/> -->

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-1" text color="grey" v-on="on">
                {{ $t("accionesReserva") }}
                </v-btn>
              </template>

              <v-card class="mx-auto" max-width="200">
                <v-list >
                  <v-list-item-group>
                    <v-list-item v-for="(accion, indice) in acciones" :key="indice" @click="elegirAccionConReserva(accion.clave)">
                      <v-list-item-content>
                        <v-list-item-title v-text="$t(accion.titulo)"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-row>
          <v-row justify="center" class="pb-2">
            <v-btn @click="entrarPagina('faq')" class="mx-1" color="grey" text>{{ $t("menuFaq") }}</v-btn>
          </v-row>
          <!-- <v-row justify="center" class="pb-2">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-1" text color="grey" v-on="on">
                {{ $t("ciudad") }}
                </v-btn>
              </template>

              <v-card class="mx-auto" max-width="300">
                <v-list >
                  <v-list-item-group>
                    <v-list-item v-for="(accion, indice) in accionesCiudad" :key="indice" @click="zonaEmisiones(accion.clave)">
   
                      <v-list-item-content>
                        <v-list-item-title v-text="$t(accion.titulo)"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-row> -->
          <v-row justify="center" class="pb-2">
            <!-- selector de idioma -->
            <SelectorIdioma v-model="idioma" @seleccion="cambiarIdioma" />
          </v-row>
        </v-container>
      </template>
    </v-app-bar>


    <v-dialog v-model="dialog" height="auto" width="60%">
      <v-card justify="center">

        <v-card-title style="background: #FAD063;">
          <v-icon color="black">mdi-parking</v-icon>
          <span class="ml-5" style="font-weight: 100;font-size: 17px;">{{ $t('miReservaTitulo') }}</span>
        </v-card-title>



        <div style="padding: 20px">

        <form @submit.prevent="handleSubmit">
            <div class="form-group entradaDatosUnico">
                <font-awesome-icon class="iconoInfo" :icon="['fas', 'envelope']" />
                <label class="ml-2" for="mail">{{ $t('datosReservaEmail') }}</label>
                <input type="email" v-model="miReserva.mail" id="mail" name="mail" class="form-control" :class="{ 'is-invalid': submitted && $v.miReserva.mail.$error }" />
                <div v-if="submitted && !$v.miReserva.mail.required" class="invalid-feedback">
                  {{ $t('errorNoEmail') }}
                </div>
                <div v-if="submitted && !$v.miReserva.mail.email" class="invalid-feedback">
                  {{ $t('errorEmailErroneo') }}
                </div>
            </div>

            <div class="form-group entradaDatosUnico">
                <font-awesome-icon class="iconoInfo" :icon="['fas', 'search-location']" />
                <label class="ml-2" for="localizador">{{ $t('datosReservaLocalizador') }}</label>
                <input type="text" v-model="miReserva.localizador"
                       id="localizador" name="localizador"
                       @click="alerta.mostrar = false"
                       class="form-control"
                       :class="{ 'is-invalid': submitted && $v.miReserva.localizador.$error }" />
                <div v-if="submitted && !$v.miReserva.localizador.required" class="invalid-feedback">
                  {{ $t('errorNoLocalizador') }}
                </div>
            </div>

            <v-alert style="margin-bottom:10px;"
                  :value="alerta.mostrar"
                  color="pink"
                  dark
                  border="top"
                  :icon="alerta.icono"
                  transition="scale-transition"
            >
              {{ this.alerta.texto }}
            </v-alert>

            <div class="form-group entradaDatosUnico">
              <v-btn class="mx-auto" color="black" outlined button @click="handleSubmit">
                {{ $t('btnBuscarReserva') }}
              </v-btn>
            </div>

        </form> <!-- fin formulario datos obligatorios para busqueda de reserva -->


        </div>
      </v-card>

    </v-dialog>


    <!-- pagina de inicio
    <router-view />
    <PiePagina></PiePagina> -->

    <div style="margin-top: 5%;"></div>
      <router-view />

   
     

    <dialogo ref="dialogo" />
    <PiePagina></PiePagina>

    <cookie-consent>
      <template
        slot="message"
      >
        {{ $t("mensajeCookies") }}

        <router-link
          :to="{ name: 'aviso_legal', params: {tipoPagina: 2 } }"
          style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
          <span style="white-space:nowrap;">{{ $t('enlaceCookies') }}</span>
        </router-link>

      </template>

      <template
        slot="button"
      >
        <button class="btn btn-info" style="background-color: #fad063;color: black;">{{ $t("aceptarCookies") }}</button>
      </template>
    </cookie-consent>

  </v-app>
</template>

<style lang="scss">
  .v-application {
    font-family: 'Manrope', sans-serif;
  }
  $cookieconstent-compliance-background:  #237afc;
  $cookieconstent-background: rgb(255, 211, 195);

  @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
  @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
  @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-transition";
</style>


<script>
import dialogo from "./components/dialogo";
import api from '@/plugins/api';
import SelectorIdioma from "@/components/SelectorIdioma.vue";
//import BuscarReserva from "@/components/BuscarReserva.vue";
import i18n from '@/plugins/i18n';
import PiePagina from "@/components/PiePagina.vue";
import { escribirLog } from '@/plugins/utilidades.js'

// validacion de formularios
import { required, email} from "vuelidate/lib/validators";


export default {
  name: "App",
  components: { SelectorIdioma, PiePagina,dialogo},

  data: () => ({
    miReserva: {
      mail: '',
      localizador: ''
    }, // fin objeto miReserva

    alerta: {
      mostrar: false,
      texto: '',
      icono: 'mdi-text-box-search-outline'
    }, //fin objeto alerta

    dialog: false,
    dialog2: true,
    submitted: false,

    acciones: [
      { titulo: "obtenerFactura", clave: 'factura'},
      { titulo: "cancelarReserva", clave: 'cancelar' },
    ], // acciones a realizar con una reserva

    accionesCiudad: [
      { titulo: "madrid", clave: 'Madrid', avatar:''},
      { titulo: "barcelona", clave: 'Barcelona', avatar: '' },
    ], // acciones a realizar con una reserva
    accionActual: '',

    menu: false,
    idioma: null
  }),

  validations: {
    miReserva: {
      mail: { required, email },
      localizador: { required }
    }
  },  // validacion de formularios con vuelidation

  created: function() {
    // recuperamos el idioma guardado para la sesion
    if (!(this.idioma = window.localStorage.getItem("idioma")))
      this.idioma = "es";
  },

  watch: {
    // el watcher se activa con cada cambio de valor de la variable
    $route() { // (to, from)
      this.ocultarMenu();
    },

    dialog () {
      // me aseguro de cerrar la ventana de alerta
      this.alerta.mostrar = false;
    }
  },

  methods: {


    elegirAccionConReserva(item){
      // me permite seleccionar la accion a realizar segun el item del menu pulsado
      escribirLog("Accion a realizar: " + item);

      this.accionActual = item;
      this.dialog=true;
    }, // fin metodo elegirAccionConReserva

    zonaEmisiones(item){
        if(item == "Barcelona"){
          this.$router.push({ path: '/zbe' })
        }else{
          this.$router.push({ path: '/zbeMadrid' })
        }

    },


    handleSubmit: function() {
      /* comprobacion de que los datos del formulario son correctos
        antes de continuar con el proceso de eliminacion de reserva */

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }


      var parametros= {
        'mail': this.miReserva.mail,
        'localizador': this.miReserva.localizador,
        'estado': 0 // en esta consulta solo me interesan reservas activas y pagadas.
      };



      api.buscarReserva(parametros)
        .then(response => {
          if (1 == response.data.existe){

            // salvamos los datos de la reserva en localStorage
            window.localStorage.setItem("importeReserva", response.data.reserva.importe);
            // las fechas de entrada/salida incluyen la informacion de la hora
            window.localStorage.setItem("fechaEntrada", response.data.reserva.inicio);
            window.localStorage.setItem("fechaSalida", response.data.reserva.final);

            window.localStorage.setItem("matricula", response.data.reserva.matricula);
            window.localStorage.setItem("modelo", response.data.reserva.modelo);

            window.localStorage.setItem("codinsclo", response.data.reserva.codinsclo);
            window.localStorage.setItem("idReservaBD", response.data.reserva.id_reserva);
            window.localStorage.setItem("localizador", response.data.reserva.localizador);
            window.localStorage.setItem("merchant_order", response.data.reserva.DS_MERCHANT_ORDER);
            window.localStorage.setItem("tarjeta", response.data.reserva.cardPan);

            window.localStorage.setItem("cif", response.data.reserva.cif);
            window.localStorage.setItem("direccion", response.data.reserva.direccion);
            window.localStorage.setItem("email", response.data.reserva.email);
            window.localStorage.setItem("nombre", response.data.reserva.nombre);
            window.localStorage.setItem("nombreFac", response.data.reserva.nombreFac);
            window.localStorage.setItem("pais", response.data.reserva.pais);
            window.localStorage.setItem("telefono", response.data.reserva.telefono);
            window.localStorage.setItem("cp", response.data.reserva.cp);
            window.localStorage.setItem("localidad", response.data.reserva.localidad);

            switch (this.accionActual) {
              case 'factura':
                //Obtener factura nominativa
                  this.dialog = false;
                  this.$router.push({ path: '/obtenerFactura' })
                break;

              case 'cancelar':
                //Cancelar reserva

                // hay que comprobar la fecha de inicio para saber si puedo anularla o no
                var ahora = this.$moment();
                var fentrada = this.$moment(response.data.reserva.inicio);

                // calcula el numero de dias hasta el inicio de la reserva
                var numeroDias = fentrada.diff(ahora, 'days', true);

                escribirLog(numeroDias);
                if (1 >= numeroDias) {
                  // fuera de plazo de cancelación
                  this.alerta.icono = 'mdi-calendar-month-outline';
                  this.alerta.texto = this.$t('errorPlazoCancelacion')
                  this.alerta.mostrar = true;

                } else {
                  // en plazo de cancelación
                  this.dialog = false;
                  this.$router.push({ path: '/cancelarReserva' })
                }

                break;
              default:
                //Accion no definida
                  this.alerta.texto = this.$t('accionNoFedinida')
                  this.alerta.mostrar = true;
                break;
            }

          } else {
            this.alerta.texto = this.$t('errorReservaNoEncontrada')
            this.alerta.mostrar = true;
          }


        })
        .catch(error => {
          escribirLog('Error ObtenerReserva');
          escribirLog(error);

          this.alerta.texto = error;
          this.alerta.mostrar = true;
        })
        .finally(() => {
          escribirLog('Final ObtenerReserva');
        })

    },  // fin metodo handleSubmit


    cambiarIdioma: function() {
      escribirLog("App: " + this.idioma);
      //  guardamos el idioma seleccionado en la sesion
      window.localStorage.setItem("idioma", this.idioma);

      i18n.locale = this.idioma;
      this.$moment().locale(this.idioma);


    }, // fin metodo cambiarIdioma
    entrarPagina (destino){
      if(destino == 'faq')
        this.$router.push({ path: '/faq' });
      else if(destino == 'nuestrosparkings')
         window.open('https://delunaparking.com', '_blank');
    },
    reservarEstancia: function(){
      // inicio de una nueva reserva.

      // Limpieza de los datos de localStorage
      window.localStorage.setItem("importeReserva", "");
      window.localStorage.setItem("importeReservaNumero", 0);
      window.localStorage.setItem("fechaEntrada", null);
      window.localStorage.setItem("fechaSalida", null);
      window.localStorage.setItem("horaSalida", "00:00");
      window.localStorage.setItem("horaEntrada", "00:00");
      window.localStorage.setItem("matricula", "");
      window.localStorage.setItem("modelo", "");
      window.localStorage.setItem("color", "");
      window.localStorage.setItem("crucero", "");

      window.localStorage.setItem("nombre", "");
      window.localStorage.setItem("mail", "");
      window.localStorage.setItem("telefono", "");
      window.localStorage.setItem("cif", "");

      window.localStorage.setItem("direccion", "");
      window.localStorage.setItem("localidad", "");
      window.localStorage.setItem("cp", "");
      window.localStorage.setItem("nombreFac", "");
      window.localStorage.setItem("pais", "");
      window.localStorage.setItem("aceptacionTerminos", false);

      // cambio de pagina
      this.$router.push({ path: '/reservar' })

    }, // fin metodo reservarEstancia

    onResize: function() {
      if (window.innerWidth > 960) this.menu = false;
    }, // fin metodo onResize

    ocultarMenu: function() {
      this.menu = false;
    }, // fin metodo ocultarMenu

   },  // fin methods

  mounted: function(){
    this.$root.$dialogo = this.$refs.dialogo;
    window.localStorage.setItem("idioma", 'ES');
  }, // fin evento mounted


};


</script>
